// Coordinates "submit the form before the task is marked done" for
// `data_input` step actions. The DataInput panel registers a submit handler
// while it is mounted; the completion flow looks the handler up by task id and
// runs it first, only completing the task when the form submit succeeds.
type DataInputSubmitHandler = () => Promise<boolean>

const handlers = new Map<string, DataInputSubmitHandler>()

export const hasDataInputSubmitHandler = (taskId: string): boolean => handlers.has(taskId)

export const registerDataInputSubmitHandler = (
  taskId: string,
  handler: DataInputSubmitHandler
): (() => void) => {
  handlers.set(taskId, handler)

  return () => {
    // Only clear if we are still the registered handler — a remount may have
    // already replaced us, in which case this unregister is a no-op.
    if (handlers.get(taskId) === handler) {
      handlers.delete(taskId)
    }
  }
}

export const submitDataInputTask = async (taskId: string): Promise<boolean> => {
  const handler = handlers.get(taskId)
  if (!handler) {
    return false
  }

  return handler()
}
